import { render } from "./P014.vue?vue&type=template&id=73af8760&scoped=true"
import script from "./P014.vue?vue&type=script&lang=js"
export * from "./P014.vue?vue&type=script&lang=js"

import "./P014.vue?vue&type=style&index=0&id=73af8760&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73af8760"]])

export default __exports__